import axiosService from "services/axios.service";
import FileDownload from "js-file-download";
import { message } from "@pankod/refine-antd";

export const exportData = async (path: string) => {
  try {
    await axiosService.get(`/v1/admin/${path}/bulk/export`).then((response) => {
      FileDownload(response.data, `${path}.csv`);
    });
    message.success(`Export ${path} success.`);
  } catch (error) {
    message.error(`Export ${path} failed.`);
    console.log(error);
  }
};
